import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

type props = {
  module: any;
  page: number;
  onPageChange: (newPage: number) => void;
  totalPages: number;
};

const SIBLINGS_COUNT = 2; // Number of pages to show on each side of current page

const getPageNumbers = (currentPage: number, totalPages: number): (number | string)[] => {
  // If 7 or fewer pages, show all
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages: (number | string)[] = [];
  
  // Always include first page
  pages.push(1);

  // Calculate the range around current page
  const leftSibling = Math.max(2, currentPage - SIBLINGS_COUNT);
  const rightSibling = Math.min(totalPages - 1, currentPage + SIBLINGS_COUNT);

  // Add left ellipsis if needed
  if (leftSibling > 2) {
    pages.push("...");
  }

  // Add pages around current page
  for (let i = leftSibling; i <= rightSibling; i++) {
    if (i !== 1 && i !== totalPages) {
      pages.push(i);
    }
  }

  // Add right ellipsis if needed
  if (rightSibling < totalPages - 1) {
    pages.push("...");
  }

  // Always include last page
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
};

const Pagination = ({ module, page, onPageChange, totalPages }: props) => {
  const pageNumbers = getPageNumbers(page, totalPages);

  return (
    <div className="pagination" style={{ marginTop: "20px" }}>
      <p>
        <span>Showing {module?.length ? `${module?.length}` : 0} items </span>
      </p>
      <div className="pages">
        <button
          className="prevbtn"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          <ArrowBackIosIcon />
        </button>
        <div className="count">
          {pageNumbers.map((pageNum, index) => (
            pageNum === "..." ? (
              <span key={`ellipsis-${index}`} className="ellipsis" style={{ padding: "0 8px", color: "#666" }}>
                ...
              </span>
            ) : (
              <button
                className={page === pageNum ? "actv" : "inActv"}
                key={pageNum}
                onClick={() => onPageChange(pageNum as number)}
                disabled={page === pageNum}
              >
                {pageNum}
              </button>
            )
          ))}
        </div>
        <button
          className="prevbtn"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          <ArrowForwardIosIcon />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
